import React, { useEffect, useState } from 'react'
import { Button, Col, message, Popconfirm, Typography } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import FormButton from '../base/FormButton'
import { deleteArtwork } from '../../api/artworks'
import HttpError from '../base/HttpError'
import { cleanAllCachedNewPieces } from './common'
import { URL_PIECES } from '../../const'

export default (props) => {
  const [stepperCount, setStepperCount] = useState(0)
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false)
  const [deletePopconfirmVisible, setDeletePopconfirmVisible] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)

  useEffect(() => {
    setStepperCount(props.stepperCount)
    if (props.actionLoading) {
      setActionLoading(true)
    }else{
      setActionLoading(false)
    }
    return () => {}
  }, [props.stepperCount, props.actionLoading])

  const onDeleteButtonClick = () => {
    setDeleteButtonLoading(true)
    Promise.all([deleteArtwork(this.getArtworkId())])
      .then((response) => {
        message.success('Delete successfully!').then((r) => {})
        props.history.push({ pathname: URL_PIECES })
      })
      .catch((error) => {
        HttpError(error)
      })
      .finally(() => {
        setDeleteButtonLoading(false)
      })
  }

  const onCancelButtonClick = () => {
    cleanAllCachedNewPieces()
    if (props.history) props.history.push({ pathname: URL_PIECES })
  }

  return (
    <FormButton>
      {props.new ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            marginRight: '10%',
            justifyContent: 'space-evenly'
          }}
        >
          <Button style={{ width: 'auto' }} block danger size='large' onClick={onCancelButtonClick}>
            Cancel
          </Button>
          {stepperCount > 0 && (
            <Button style={{ width: 'auto' }} block size='large' onClick={() => props.prev()}>
              Previous
            </Button>
          )}
          {stepperCount < 3 && (
            <Button block type='primary' size='large' htmlType='submit' style={{ width: 'auto' }} loading={actionLoading} disabled={actionLoading}>
              Save & Continue
            </Button>
          )}
          {stepperCount === 3 && (
            <Button block type='primary' size='large' htmlType='submit' style={{ width: 'auto' }} loading={actionLoading}
                disabled={actionLoading}
                >
              Create Piece
            </Button>
          )}
        </div>
      ) : (
        <>
          <Col span={1} offset={2}>
            <Popconfirm
              placement='top'
              title='Are you sure you want to permanently delete this and all its associated records?'
              visible={deletePopconfirmVisible}
              onConfirm={onDeleteButtonClick}
              okButtonProps={{ loading: deleteButtonLoading, disabled: deleteButtonLoading  }}
              onCancel={() => {
                setDeletePopconfirmVisible(false)
              }}
            >
              <Button
                block
                danger
                size='large'
                onClick={() => {
                  setDeletePopconfirmVisible(true)
                }}
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </Col>
          <Col offset={2}>
            <Button block danger size='large' onClick={props.history.goBack}>
              Cancel
            </Button>
          </Col>
          <Col span={4} offset={2}>
            <Button block type='primary' size='large' htmlType='submit' loading={actionLoading} disabled={actionLoading}>
              Update Piece
            </Button>
          </Col>
        </>
      )}
    </FormButton>
  )
}
